// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "view-static/css/" + chunkId + "." + {"10":"9a4482df","52":"5bc3da51","94":"dd6298c4"}[chunkId] + ".css";
};